import { useEffect, useState } from 'react'
import { useAnalyticsClient } from '@acorns/web-utils'
import { translateEventProps } from 'utils/analytics/eventSpec'

export const ACTIONS = {
  SCREEN_VIEW: 'Screen Viewed',
  CONTAINER_VIEWED: 'Container Viewed',
}

type AnalyticsOptionsInput = {
  action?: string
  payload?: object
  generatedPayload?: [string, object]
}

export const useAnalyticsComponentViewed = ({
  action: manualAction,
  payload: manualPayload,
  generatedPayload,
}: AnalyticsOptionsInput): void => {
  const [hasFired, setHasFired] = useState(false)
  const analytics = useAnalyticsClient()

  const action = generatedPayload ? generatedPayload[0] : manualAction
  const payload = generatedPayload ? generatedPayload[1] : manualPayload

  useEffect(() => {
    if (!hasFired) {
      analytics.track(action, translateEventProps(payload))
      setHasFired(true)
    }
  }, [action, analytics, hasFired, payload])
}
